import { Action } from '@ngrx/store';
import { GameDayModel } from '../../models/gameday-model';
import { AccountManager, GameDayViewType, GamedayFiltersState } from './state';

export enum GamedayActionTypes {
  SetViewType = '[Gameday] Set view type',
  SetRawData = '[Gameday] Set raw data',
  SetFilters = '[Gameday] Set filters',
  SetSearchBy = '[Gameday] Set search by',
  FilterBySealedBid = '[Gameday] Filter by sealed bid',
  FilterByStock = '[Gameday] Filter by stock',
  FilterBySeries = '[Gameday] Filter by series',
  FilterByLegends = '[Gameday] Filter by legends',
  ShowMarketDrawers = '[Gameday] Show market drawers',
  ResetData = '[Gameday] Reset data'
}

export class SetRawData implements Action {
  public readonly type: string = GamedayActionTypes.SetRawData;

  constructor(public readonly payload: GameDayModel.RawData) {}
}

export class SetGamedayViewType implements Action {
  public readonly type: string = GamedayActionTypes.SetViewType;

  constructor(public readonly payload: GameDayViewType) {}
}

export class SetFilters implements Action {
  public readonly type: string = GamedayActionTypes.SetFilters;

  constructor(public readonly payload: GamedayFiltersState) {}
}

export class SetSearchBy implements Action {
  public readonly type: string = GamedayActionTypes.SetSearchBy;
  public readonly location: boolean = true; // ToDo: Not sure if need

  constructor(public readonly payload: AccountManager) {}
}

export class FilterBySealedBid implements Action {
  public readonly type: string = GamedayActionTypes.FilterBySealedBid;
  public readonly location: boolean = true; // ToDo: Not sure if need

  constructor(public readonly payload: boolean) {}
}

export class FilterByStock implements Action {
  public readonly type: string = GamedayActionTypes.FilterByStock;
  public readonly location: boolean = true; // ToDo: Not sure if need

  constructor(public readonly payload: boolean) {}
}

export class FilterBySeries implements Action {
  public readonly type: string = GamedayActionTypes.FilterBySeries;
  public readonly location: boolean = true; // ToDo: Not sure if need

  constructor(public readonly payload: string[]) {}
}

export class FilterByLegends implements Action {
  public readonly type: string = GamedayActionTypes.FilterByLegends;

  constructor(public readonly payload: string[]) {}
}

export class ShowMarketDrawers implements Action {
  public readonly type: string = GamedayActionTypes.ShowMarketDrawers;

  constructor(public readonly payload: boolean) {}
}

export class ResetData implements Action {
  public readonly type: string = GamedayActionTypes.ResetData;
  public readonly payload: undefined = undefined;
}

export type GamedayActionUnion =
  | SetRawData
  | SetGamedayViewType
  | SetFilters
  | FilterBySealedBid
  | FilterByStock
  | FilterBySeries
  | FilterByLegends
  | SetSearchBy
  | ShowMarketDrawers
  | ResetData;
